import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';

/* --- Icônes SVG --- */
const IconMail = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
);
const IconMap = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
);
const IconPhone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
);

export default function Contact() {
  const form = useRef(); // Référence au formulaire HTML
  
  // États pour gérer les champs et le statut d'envoi
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // null | 'success' | 'error'

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    // REMPLACEZ CES VALEURS PAR LES VÔTRES (Récupérées à l'étape 1)
    const SERVICE_ID = 'service_js66mlo'; 
    const TEMPLATE_ID = 'template_xh0qy8i'; 
    const PUBLIC_KEY = 'AKuuFzb1jFhqV_ykn'; 

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
      .then((result) => {
          setLoading(false);
          setStatus('success');
          e.target.reset(); // Vide le formulaire
      }, (error) => {
          setLoading(false);
          setStatus('error');
          console.error(error.text);
      });
  };

  return (
    <div className="container section">
      
      {/* --- En-tête --- */}
      <div style={{ textAlign: 'center', marginBottom: '60px' }}>
        <h1 style={{ marginBottom: '15px' }}>Parlons de votre projet</h1>
        <p style={{ maxWidth: '600px', margin: '0 auto', color: 'var(--text-grey)' }}>
          Nos équipes techniques et stratégiques sont prêtes à vous répondre. 
          Remplissez le formulaire, nous revenons vers vous sous 24h.
        </p>
      </div>

      {/* --- Layout 2 Colonnes --- */}
      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: '40px', 
        justifyContent: 'center' 
      }}>
        
        {/* Colonne Gauche : Informations */}
        <div style={{ 
          flex: '1 1 300px', 
          maxWidth: '400px',
          background: 'var(--dark)', 
          color: 'white', 
          padding: '40px', 
          borderRadius: 'var(--radius)',
          boxShadow: 'var(--shadow)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}>
          <div>
            <h3 style={{ color: 'white', marginBottom: '30px', borderBottom: '2px solid var(--primary)', paddingBottom: '10px', display:'inline-block' }}>
              Coordonnées
            </h3>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
              
             
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <div style={{ color: 'var(--primary)' }}><IconMail /></div>
                <div>
                  <h4 style={{ fontSize: '1rem', color: '#E2E8F0', marginBottom: '4px' }}>Email</h4>
                  <a href="mailto:contacts@landagroup.fr" style={{ color: 'white', textDecoration: 'underline', fontSize: '0.95rem' }}>
                    contacts@landagroup.fr
                  </a>
                </div>
              </div>

              
            </div>
          </div>

          <div style={{ marginTop: '40px', padding: '20px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
            <p style={{ fontSize: '0.9rem', fontStyle: 'italic', color: '#A0AEC0' }}>
              "L'innovation commence par une simple discussion."
            </p>
          </div>
        </div>

        {/* Colonne Droite : Formulaire */}
        <div style={{ 
          flex: '1 1 400px', 
          maxWidth: '600px',
          background: 'white', 
          padding: '40px', 
          borderRadius: 'var(--radius)', 
          boxShadow: '0 10px 30px rgba(0,0,0,0.08)' 
        }}>
          
          <form ref={form} onSubmit={sendEmail}>
            
            {/* Nom */}
            <div className="form-group">
              <label style={{ fontSize: '0.9rem', fontWeight: '600', color: 'var(--dark)' }}>Votre Nom</label>
              <input 
                type="text" 
                name="user_name" // Important: doit correspondre à {{user_name}} dans EmailJS
                className="form-input" 
                placeholder="Jean Dupont"
                required 
              />
            </div>

            {/* Email */}
            <div className="form-group">
              <label style={{ fontSize: '0.9rem', fontWeight: '600', color: 'var(--dark)' }}>Email Professionnel</label>
              <input 
                type="email" 
                name="user_email" // Important: correspond à {{user_email}}
                className="form-input" 
                placeholder="jean@entreprise.com"
                required 
              />
            </div>

            {/* Sujet (Nouveau) */}
            <div className="form-group">
              <label style={{ fontSize: '0.9rem', fontWeight: '600', color: 'var(--dark)' }}>Sujet de la demande</label>
              <select 
                name="subject" // Important: correspond à {{subject}}
                className="form-input" 
                style={{ cursor: 'pointer' }}
                required
              >
                <option value="">Sélectionnez un sujet...</option>
                <option value="Devis Projet Web">Demande de devis (Web/App)</option>
                <option value="Audit & Conseil">Audit & Conseil Stratégique</option>
                <option value="Demo Landadoc">Démo produit Landadoc</option>
                <option value="Demo PMS">Démo produit LandaCare PMS</option>
                <option value="Partenariat">Proposition de Partenariat</option>
                <option value="Autre">Autre demande</option>
              </select>
            </div>

            {/* Message */}
            <div className="form-group">
              <label style={{ fontSize: '0.9rem', fontWeight: '600', color: 'var(--dark)' }}>Message</label>
              <textarea 
                name="message" // Important: correspond à {{message}}
                className="form-textarea" 
                placeholder="Décrivez votre besoin en quelques lignes..."
                required
              ></textarea>
            </div>

            {/* Bouton & Feedback */}
            <button 
              type="submit" 
              className="btn btn-primary" 
              style={{ width: '100%', marginTop: '10px' }}
              disabled={loading} // Désactive le bouton pendant l'envoi
            >
              {loading ? 'Envoi en cours...' : 'Envoyer ma demande'}
            </button>

            {/* Messages de succès/erreur */}
            {status === 'success' && (
              <div style={{ marginTop: '20px', padding: '15px', background: '#DEF7EC', color: '#03543F', borderRadius: '8px', border: '1px solid #84E1BC', textAlign: 'center' }}>
                <strong>Message envoyé avec succès !</strong><br/>
                Nous vous répondrons très rapidement sur l'adresse indiquée.
              </div>
            )}
            
            {status === 'error' && (
              <div style={{ marginTop: '20px', padding: '15px', background: '#FDE8E8', color: '#9B1C1C', borderRadius: '8px', border: '1px solid #F8B4B4', textAlign: 'center' }}>
                Une erreur est survenue. Veuillez réessayer ou nous écrire directement à contacts@landagroup.fr
              </div>
            )}

          </form>
        </div>

      </div>
    </div>
  );
}